import { Injectable } from '@angular/core';

import { AuthStorageService, RoutingService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShimanoAuthRedirectService } from 'src/app/service/auth/shimano-auth-redirect.service';
import { StorageService } from 'src/app/service/storage/storage.service';
import { ASM_ENABLED_LOCAL_STORAGE_KEY } from '../../../asm/asm-constant';

@Injectable({
  providedIn: 'root',
})
export class NotAuthGuard {
  asmEnabled = this.storageService.getLocalStorageItem(ASM_ENABLED_LOCAL_STORAGE_KEY);
  constructor(
    protected routingService: RoutingService,
    protected authStorageService: AuthStorageService,
    private authRedirectService: ShimanoAuthRedirectService,
    private storageService: StorageService
  ) {}

  canActivate(): Observable<boolean> {
    this.authRedirectService.reportNotAuthGuard();

    // redirect, if user is already logged in:
    return this.authStorageService.getToken().pipe(
      map((token) => {
        if (token.access_token) {
          if (this.asmEnabled) {
            this.routingService.go({ cxRoute: 'dealerSelection' });
          } else {
            this.routingService.go({ cxRoute: 'home' });
          }
        }
        return !token.access_token;
      })
    );
  }
}
